import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useGetFacebookPixels } from '../../../../../api/getFacebookPixels'
import { useSetSelectedFacebookPixels } from '../../../../../api/setFacebookPixels'
import { SelectPixelsTocError } from './SelectPixelsTocError/SelectPixelsTocError'
import { useIdsList } from '../../../../../hooks/useIdsList'
import { useSetSingularDomainToPixels } from '../../../../../hooks/useSetSingularDomainToPixels'
import { useGetErrorText } from '../../../../../../../utils/errorText'

import { PixelIdsInner } from './PixelIdsInner/PixelIdsInner'

export const SelectPixelId = ({
  onSubmit,
  onSkipNextStep,
  accountId,
  onBack,
  isBackDisabled,
}: {
  onSubmit: () => void
  onSkipNextStep: () => void
  accountId: number
  onBack: () => void
  isBackDisabled?: boolean
}) => {
  const { t } = useTranslation('PMPlatforms')
  const [url, setUrl] = useState<string>('')
  const { isSingularDomain, checkAssignPixelsToDomain } = useSetSingularDomainToPixels({
    accountId,
  })
  const { data, isFetching } = useGetFacebookPixels({ connectionId: accountId })

  const pixels = useMemo(() => {
    return data instanceof Error || !data?.pixels ? [] : data.pixels
  }, [data])

  const {
    filteredOptions,
    handleCheckboxClicked,
    handleSelectAll,
    selectedOptions,
    setFilterBy,
    filterBy,
    handleSortChange,
    sortOrder,
  } = useIdsList(pixels)

  const { mutate, isLoading } = useSetSelectedFacebookPixels()
  const { getErrorText } = useGetErrorText()

  const getUrl = (text: string) => {
    if (text.length === 0) return ''
    const keyword = 'https://'
    const parts: Array<string> = text.split(keyword)
    return keyword + parts.slice(1).join(keyword)
  }
  const handleSubmit = () => {
    mutate(
      {
        connectionId: accountId,
        pixelIds: selectedOptions,
      },
      {
        onSuccess: (data) => {
          if (!(data instanceof Error)) {
            isSingularDomain
              ? // if one domain - sett selected pixels to that domain and skip next step
                checkAssignPixelsToDomain(data.selectedPixels, onSkipNextStep)
              : onSubmit()
          } else {
            const errorText = getErrorText(data, true)
            if (errorText?.includes('#2663')) {
              setUrl(getUrl(errorText))
            }
          }
        },
      }
    )
  }

  return (
    <PixelIdsInner
      options={filteredOptions}
      selected={selectedOptions}
      title={t('meta-connection-wizard.select-pixel-id-title')}
      searchPlaceholder={t('meta-connection-wizard.select-pixel-id-search-pholder')}
      filterBy={filterBy}
      buttonLoading={isLoading}
      modalLoading={isFetching}
      buttonText={t('next-button')}
      entitiesName={t('meta-connection-wizard.pixel')}
      handleSelect={handleCheckboxClicked}
      onSearch={setFilterBy}
      handleSelectAll={handleSelectAll}
      handleSubmit={handleSubmit}
      onBack={onBack}
      handleSortChange={handleSortChange}
      messageBox={
        url.length > 0
          ? {
              content: <SelectPixelsTocError url={url} />,
              type: 'failure' as const,
            }
          : undefined
      }
      sortDirection={sortOrder}
      isBackButtonDisabled={isBackDisabled}
    />
  )
}
